<template>
    <default-item class="bimini_food_item--container" :item="item"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-22 (1.0.0) (jhoward)
 *      - <wineListItem> copied to <biminiFoodItem>.
 *
 *    2023-04-21 (1.1.0) (jhoward)
 *      - <biminiFoodItem> now uses <default-item>.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <bimini-food-item>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'biminiFoodItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
})
</script>

<style scoped>
.bimini_food_item--container >>> .menu--item-highlighted {
  background-color: #f7f3eb;
}
</style>